var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 38C29.4934 38 38 29.4934 38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19C0 29.4934 8.50659 38 19 38Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5986 13.2209C27.899 13.5305 27.1489 13.7401 26.3603 13.834C27.1654 13.3529 27.7817 12.5893 28.0739 11.6829C27.3187 12.1287 26.4853 12.4522 25.5968 12.6273C24.8859 11.8704 23.8745 11.3984 22.7525 11.3984C20.6 11.3984 18.8545 13.1408 18.8545 15.2878C18.8545 15.5928 18.889 15.8901 18.9554 16.1746C15.7164 16.0124 12.8448 14.4631 10.9223 12.1097C10.5864 12.6832 10.3955 13.3513 10.3955 14.0651C10.3955 15.4146 11.0838 16.606 12.1287 17.3028C11.4897 17.2812 10.8894 17.1061 10.3631 16.8145V16.8632C10.3631 18.7473 11.7073 20.3202 13.4894 20.6781C13.1627 20.7654 12.8185 20.8142 12.4625 20.8142C12.2105 20.8142 11.9671 20.7896 11.7284 20.7418C12.2249 22.2885 13.6638 23.4131 15.3686 23.4439C14.0352 24.4869 12.3545 25.1067 10.5282 25.1067C10.2134 25.1067 9.9037 25.0877 9.59863 25.0533C11.3236 26.1594 13.3716 26.8038 15.5729 26.8038C22.7427 26.8038 26.6623 20.8758 26.6623 15.7351L26.6489 15.2313C27.4149 14.686 28.0775 14.0009 28.5986 13.2209Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 19,
    x2: 38,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F45FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6365"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareTwitter);
export default __webpack_public_path__ + "static/media/share-twitter.d01b383f.svg";
export { ForwardRef as ReactComponent };